import { FC } from 'react';

import ExcipientTypeListing from 'components/main/ExcipientType';

const ExcipientType: FC = () => <ExcipientTypeListing />;

export default ExcipientType;
